/**
 * Fetch client game configuration
 * Store translations and bets
 *
 * @param {String} lang
 * @param {String} game
 */
function fetchClientGameConfiguration(lang, game) {
  const headers = {
    'Content-Type': 'application/json',
    'HTTP-X-NAB-TOKEN': 'sportradarToken',
    'HTTP-X-SEVEN-COMPANY-UUID': `${window.sevenConfig.company.uuid}`,
    'HTTP-X-NAB-COMPANY-UUID': `${window.sevenConfig.company.uuid}`,
    'HTTP-SEVEN-LOCALE': lang,
  };
  const gameConfigApi = `${window.sevenConfig.integrationsApiLocation.productApi.url}${process.env.VUE_APP_CONFIG_URL}${game}?channel=retail`;
  return axios.get(gameConfigApi, { headers });
}

/**
 * Fetch api location servers
 */
function fetchApiLocation(id, game) {
  const apiLocationUrl = `${process.env.VUE_APP_API_LOCATION_URL}${id}/${game}`;
  return axios.get(apiLocationUrl);
}

export default {
  getGameConfig: fetchClientGameConfiguration,
  getApiLocation: fetchApiLocation,
};
